import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useBoolean } from 'ahooks';
import { Button } from 'antd';

import { snapStore } from 'containers/Snaps/Snap/store';

import { usePutRequest } from 'hooks';

import { SnapDetails } from 'codegen';

import { handleCompleteError, handleCompleteSuccess } from './lib';

export const CompleteProcessingButton = () => {
  const isCompleteProcessingAllowed = snapStore((state) => state.snapBooleanStatuses.isCompleteProcessingAllowed);

  const { snapId } = useParams();
  const [dsiabled, { setTrue, setFalse }] = useBoolean(false);

  const [handleIssuance, { loading }] = usePutRequest<SnapDetails>({
    url: `/snaps/${snapId}/corrections/issuance`,
    options: {
      onError: handleCompleteError,
      onSuccess: (repsonse) => {
        setTrue();
        handleCompleteSuccess(repsonse);
      },
    },
  });

  useEffect(() => {
    setFalse();
  }, [snapId]);

  return (
    <Button
      size='small'
      type='primary'
      loading={loading}
      className='bg-green-500'
      disabled={!isCompleteProcessingAllowed || dsiabled}
      onClick={() => handleIssuance()}
    >
      Complete Processing
    </Button>
  );
};
